import { combineReducers } from 'redux';
import turtle from './turtle';

const rootReducer = combineReducers({
  turtle
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/reducers/index.js